import React from 'react';
import { GlobalStyles, SYS_COLOR_CANVAS_DEFAULT_DARK, SYS_COLOR_CANVAS_INVERTED_DARK, SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_DARK, SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_LIGHT, SYS_COLOR_SURFACE_SIGNAL_INDICATOR_DEFAULT_DARK, GLOBAL_COLOR_TYPOGRAPHY_HEADLINE_ORDER1_LIGHT, ThemeProvider, GLOBAL_BOX_SHADOW_ELEVATION_LEVEL1_LIGHT, SYS_ELEVATION_LEVEL4_LIGHT, SYS_COLOR_SURFACE_NEUTRAL_700_DARK, SYS_COLOR_SURFACE_NEUTRAL_700_LIGHT, SYS_COLOR_SURFACE_NEUTRAL_100_DARK, } from '@oneaudi/unified-web-common';
import { GlobalStyles as AlphaGlobalStyles, SYS_COLOR_CANVAS_200_DARK, SYS_COLOR_CANVAS_200_LIGHT, SYS_GRADIENT_SURFACE_INTERACTIVE_TILE_FILL_100_DARK, SYS_GRADIENT_SURFACE_INTERACTIVE_TILE_FILL_100_LIGHT, SYS_COLOR_FOREGROUND_ON_SIGNAL_100_DARK, SYS_COLOR_SURFACE_NEUTRAL_600_DARK, SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_FILL_DARK, SYS_BLUR_BACKGROUND_100, SYS_COLOR_SURFACE_NEUTRAL_100_DARK as SYS_COLOR_SURFACE_NEUTRAL_100_DARK_ALPHA, SEM_COLOR_FORMS_FOREGROUND_DIVIDER_DEFAULT_DARK, } from '@oneaudi/unified-web-alpha-common';
export const DynamicThemeProviderWrapper = ({ isDemo, children }) => (React.createElement(ThemeProvider, { theme: isDemo
        ? {
            iconBasePath: 'icons',
            name: dynamicStylingHelper('light', 'dark'),
        }
        : {
            name: dynamicStylingHelper('light', 'dark'),
        } }, children));
export const DynamicGlobalStyles = () => {
    if (process.env.IS_LEGACY || process.env.IS_LEGACY === undefined) {
        return React.createElement(GlobalStyles, null);
    }
    else {
        return React.createElement(AlphaGlobalStyles, { hasGlobalBackgroundColor: true, themeName: "dark" });
    }
};
export const GetSafeColorDesignToken = (color) => {
    if (process.env.IS_LEGACY || process.env.IS_LEGACY === undefined) {
        const legacyTokens = {
            dark: SYS_COLOR_CANVAS_DEFAULT_DARK,
            inverted: SYS_COLOR_CANVAS_INVERTED_DARK,
            'interactive-light': SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_LIGHT,
            'interactive-dark': SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_DARK,
            INDICATOR_DEFAULT_DARK: SYS_COLOR_SURFACE_SIGNAL_INDICATOR_DEFAULT_DARK,
            HEADLINE_ORDER1_LIGHT: GLOBAL_COLOR_TYPOGRAPHY_HEADLINE_ORDER1_LIGHT,
            'shadow-l1': GLOBAL_BOX_SHADOW_ELEVATION_LEVEL1_LIGHT,
            'shadow-l4': SYS_ELEVATION_LEVEL4_LIGHT,
            FILTER_OVERLAY: SYS_COLOR_CANVAS_INVERTED_DARK,
            FILTER_OVERLAY_NAVIGATION: SYS_COLOR_CANVAS_DEFAULT_DARK,
            FILTER_OVERLAY_FOOTER: SYS_COLOR_CANVAS_DEFAULT_DARK,
            EQUIPMENT_ACCORDION_SECTION: SYS_COLOR_SURFACE_NEUTRAL_700_DARK,
            MOBILE_NAVIGATION: 'rgb(242, 242, 242)',
            MODEL_FILTER_ACCORDION_OPENED: SYS_COLOR_SURFACE_NEUTRAL_700_LIGHT,
            MODEL_FILTER_ACCORDION_CLOSED: SYS_COLOR_SURFACE_NEUTRAL_100_DARK,
            MODEL_FILTER_ACCORDION_CLOSED_MOBILE: 'rgb(242, 242, 242)',
            FILTER_OVERLAY_BLUR: '',
            EQUIPMENT_OVERLAY_HEADER: '',
            DEALER_ACCORDION: SYS_COLOR_CANVAS_INVERTED_DARK,
            DEALER_ACCORDION_OPEN: SYS_COLOR_CANVAS_INVERTED_DARK,
            FOCUSED_DEALER: SYS_COLOR_SURFACE_NEUTRAL_600_DARK,
            FILTER_OVERLAY_DIVIDER: SYS_COLOR_CANVAS_INVERTED_DARK,
            FILTER_OVERLAY_HEADER: SYS_COLOR_CANVAS_DEFAULT_DARK,
            MODEL_FILTER_ACCORDION_PLACEHOLDER_HOVER: 'unset',
            QUICK_FILTERS_FOOTER: SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_DARK,
        };
        return legacyTokens[color];
    }
    else {
        const alphaTokens = {
            dark: SYS_COLOR_CANVAS_200_DARK,
            inverted: SYS_COLOR_CANVAS_200_LIGHT,
            'interactive-light': SYS_GRADIENT_SURFACE_INTERACTIVE_TILE_FILL_100_LIGHT,
            'interactive-dark': SYS_GRADIENT_SURFACE_INTERACTIVE_TILE_FILL_100_DARK,
            INDICATOR_DEFAULT_DARK: SYS_COLOR_FOREGROUND_ON_SIGNAL_100_DARK,
            HEADLINE_ORDER1_LIGHT: SYS_COLOR_SURFACE_NEUTRAL_100_DARK_ALPHA,
            'shadow-l1': 'none',
            'shadow-l4': 'none',
            FILTER_OVERLAY: SYS_COLOR_CANVAS_200_DARK,
            FILTER_OVERLAY_NAVIGATION: SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_FILL_DARK,
            FILTER_OVERLAY_FOOTER: SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_FILL_DARK,
            EQUIPMENT_ACCORDION_SECTION: SYS_COLOR_CANVAS_200_DARK,
            MOBILE_NAVIGATION: SYS_COLOR_CANVAS_200_DARK,
            MODEL_FILTER_ACCORDION_OPENED: SYS_COLOR_SURFACE_NEUTRAL_600_DARK,
            MODEL_FILTER_ACCORDION_CLOSED: SYS_COLOR_CANVAS_200_DARK,
            MODEL_FILTER_ACCORDION_CLOSED_MOBILE: SYS_COLOR_CANVAS_200_DARK,
            FILTER_OVERLAY_BLUR: SYS_BLUR_BACKGROUND_100,
            EQUIPMENT_OVERLAY_HEADER: SYS_BLUR_BACKGROUND_100,
            DEALER_ACCORDION: SYS_COLOR_SURFACE_NEUTRAL_600_DARK,
            DEALER_ACCORDION_OPEN: SYS_COLOR_SURFACE_NEUTRAL_600_DARK,
            FOCUSED_DEALER: SYS_COLOR_SURFACE_NEUTRAL_600_DARK,
            FILTER_OVERLAY_DIVIDER: SEM_COLOR_FORMS_FOREGROUND_DIVIDER_DEFAULT_DARK,
            FILTER_OVERLAY_HEADER: SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_FILL_DARK,
            MODEL_FILTER_ACCORDION_PLACEHOLDER_HOVER: SYS_COLOR_SURFACE_NEUTRAL_600_DARK,
            QUICK_FILTERS_FOOTER: SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_FILL_DARK,
        };
        return alphaTokens[color];
    }
};
export const DynamicWrapper = ({ children, LegacyWrapperFc, AlphaWrapperFc }) => {
    if (!children) {
        return null;
    }
    else if (process.env.IS_LEGACY || process.env.IS_LEGACY === undefined) {
        if (LegacyWrapperFc) {
            return React.createElement(LegacyWrapperFc, null, children);
        }
        return React.createElement(React.Fragment, null, children);
    }
    else {
        if (AlphaWrapperFc) {
            return React.createElement(AlphaWrapperFc, null, children);
        }
        return React.createElement(React.Fragment, null, children);
    }
};
export const DynamicComponent = ({ legacy, alpha, }) => {
    if (process.env.IS_LEGACY || process.env.IS_LEGACY === undefined) {
        return legacy;
    }
    else {
        return alpha;
    }
};
export function dynamicStyling({ legacy, alpha }) {
    if (process.env.IS_LEGACY || process.env.IS_LEGACY === undefined) {
        return legacy !== null && legacy !== void 0 ? legacy : (typeof alpha === 'string' ? '' : legacy);
    }
    else {
        return alpha !== null && alpha !== void 0 ? alpha : (typeof legacy === 'string' ? '' : alpha);
    }
}
export function dynamicStylingHelper(unifiedStylingInput, alphaStylingInput) {
    return dynamicStyling({ legacy: unifiedStylingInput, alpha: alphaStylingInput });
}
export const getDesignLibrary = (props) => {
    if (process.env.IS_LEGACY || process.env.IS_LEGACY === undefined) {
        return {
            '@oneaudi/unified-web-common': (props === null || props === void 0 ? void 0 : props.unifiedWebCommonVersion) || '*',
        };
    }
    else {
        return {
            '@oneaudi/unified-web-alpha-common': (props === null || props === void 0 ? void 0 : props.unifiedWebAlphaCommonVersion) || '*',
        };
    }
};
export const isLegacy = process.env.IS_LEGACY || process.env.IS_LEGACY === undefined;
